import { useState } from 'react'
import { RhyBusButton } from '@rhybus/button'
import { RhyBusPopOver } from '@rhybus/popover'
import { RhyBusTextArea } from '@rhybus/form-controls'
export default function PricingButton() {
    const [visible, setVisible] = useState(false)
      const handleClose = () => {
        setVisible(false)
    }
    return (
        <RhyBusPopOver
            placement="bottom-left"
            trigger="click"
            popoverclassName="detail-view-recordcost-popover action-btn-popover popup-md"
            visible={visible}
            onVisibleChange={setVisible}
            content={
                <div className="d-flex flex-column gap-3 detail-view-popover-form">
                    <RhyBusTextArea
                        id="approve-comments"
                        label="Comments"
                        value={''}
                        rows={6}
                        isMandatory
                        placeholder="Enter comments"
                        labelClassName='inter-medium font-14'
                        info="Add notes for the selected status update"
                        tooltipPlacement="top"
                    />
                    </div>
            }
            footer={
                <div className="d-flex justify-content-end gap-2">
                    <RhyBusButton label="Ok" variant="primary" leftIcon='icon-rb-checked' size="md"
                        />
                    <RhyBusButton label="Cancel" variant="primary" leftIcon='icon-rb-close color-primary font-10' size="md"
                        onClick={handleClose}
                        style={{ '--rb-btn-bg': '#FFFFFF', '--rb-btn-border': '#BACBD9', '--rb-btn-text': '#596F80', '--rb-btn-hover-bg': '#fff', '--rb-btn-active-bg': '#fff', '--rb-btn-hover-border': '#BACBD9' }}
                    />
                </div>
            }
        >
            <RhyBusButton
                label="Pricing"
                leftIcon="icon-rb-dollar-coins font-16"
                variant="primary"
                pill={true}
                ariaLabel="Pricing"
                style={{ '--rb-btn-bg': '#A91773' }}
            />
        </RhyBusPopOver>
    )
}
